'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var shadows = {};

exports.__exports = shadows;
